/**
 * 관리자 액세스 토큰 저장소.
 *
 * 저장 위치를 이 파일 한 곳에만 둔다 — 메모리 ↔ 스토리지를 바꿔도 여기만 고치면 된다.
 * `localStorage` 를 쓰는 이유는 **탭마다 로그인이 풀리면 안 되기 때문**이다 —
 * `sessionStorage` 는 이름과 달리 탭 단위라 새 탭에서 주소를 직접 열면 빈 저장소가 된다.
 * 운영자는 대진 편성과 신청 목록을 여러 탭에 띄워 놓고 쓴다.
 *
 * 그래서 탭을 닫아도 토큰이 남는다 — 공용 PC 에서는 로그아웃으로 지워야 한다.
 * 만료는 서버가 정한다(액세스 토큰 8시간). 만료 · 위조 토큰은 `ApiClient` 가 401 을 받는
 * 즉시 지운다.
 */
const ACCESS_TOKEN_KEY = "fight-bracket.admin.accessToken"

function readAccessToken(): string {
  if (typeof localStorage === "undefined") return ""

  return localStorage.getItem(ACCESS_TOKEN_KEY) ?? ""
}

function writeAccessToken(accessToken: string) {
  if (typeof localStorage === "undefined") return

  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
}

function clearAccessToken() {
  if (typeof localStorage === "undefined") return

  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

function hasAccessToken(): boolean {
  return readAccessToken().length > 0
}

export { clearAccessToken, hasAccessToken, readAccessToken, writeAccessToken }
